import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import '../Articulos/Articulos.css';
import './ArticuloDetalle.css';

const API     = 'https://centrocomunicar.com/api-comunicar/endpoints/articulos.php';
const API_COM = 'https://centrocomunicar.com/api-comunicar/endpoints/articulos_comentarios.php';

const LogoComunicar = ({ height = 40 }) => (
  <img 
    src="/images/logo_centro.png" 
    alt="Comunicar" 
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

const CAT_COLORS = {
  Lenguaje:'#4db88a', TEA:'#60a5fa', Habla:'#fbbf24',
  Aprendizaje:'#a78bfa', Familia:'#f9a8d4', Tartamudez:'#fb7185',
  Recursos:'#34d399', General:'#9ca3af',
};

function calcLectura(contenido) {
  if (!contenido) return 1;
  return Math.max(1, Math.ceil(contenido.replace(/<[^>]+>/g,'').split(/\s+/).length / 200));
}

function Avatar({ nombre, size = 36, bg = '#111614', color = '#82D8B3' }) {
  return (
    <div style={{
      width:size, height:size, borderRadius:'50%', background:bg,
      display:'flex', alignItems:'center', justifyContent:'center',
      fontSize:size*.38, fontWeight:700, color, flexShrink:0,
    }}>
      {(nombre||'?')[0].toUpperCase()}
    </div>
  );
}

function ShareBtn({ href, bg, children }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="artd-share-btn" style={{ background:bg }}>
      {children}
    </a>
  );
}

const IcoFacebook  = () => <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>;
const IcoX         = () => <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>;
const IcoWhatsapp  = () => <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;
const IcoLinkedin  = () => <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>;

export default function ArticuloDetalle() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { estaLogueado, usuario } = useAuthUser();

  const [art,         setArt]         = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [copied,      setCopied]      = useState(false);
  const [comentarios, setComentarios] = useState([]);
  const [formCom,     setFormCom]     = useState({ nombre:'', email:'', texto:'' });
  const [enviando,    setEnviando]    = useState(false);
  const [comMsg,      setComMsg]      = useState(null);
  const [likes,       setLikes]       = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      setLoading(true);
      try {
        const r = await fetch(`${API}?action=detail&slug=${slug}`);
        const j = await r.json();
        if (!j.success) { navigate('/articulos'); return; }
        setArt(j.data);
        fetch(`${API}?action=sumar_vista`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: j.data.id }),
        }).catch(()=>{});
        cargarComentarios(j.data.id);
      } catch { navigate('/articulos'); }
      finally { setLoading(false); }
    })();
  }, [slug]);

  const cargarComentarios = async (artId) => {
    try {
      const r = await fetch(`${API_COM}?action=list&articulo_id=${artId}`);
      const j = await r.json();
      if (j.success) setComentarios(j.data || []);
    } catch {}
  };

  const enviarComentario = async () => {
    if (!formCom.nombre.trim() || !formCom.texto.trim()) {
      setComMsg({ tipo:'error', texto:'El nombre y el comentario son obligatorios.' });
      return;
    }
    setEnviando(true);
    setComMsg(null);
    try {
      const r = await fetch(`${API_COM}?action=crear`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ ...formCom, articulo_id: art.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setComMsg({ tipo:'ok', texto:'¡Comentario enviado! Aparecerá tras ser revisado.' });
      setFormCom({ nombre:'', email:'', texto:'' });
      cargarComentarios(art.id);
    } catch(e) {
      setComMsg({ tipo:'error', texto: e.message || 'Error al enviar.' });
    } finally { setEnviando(false); }
  };

  const darLike = async (comId) => {
    if (likes[comId]) return;
    setLikes(p => ({ ...p, [comId]: true }));
    setComentarios(p => p.map(c => c.id === comId ? { ...c, likes:(c.likes||0)+1 } : c));
    try {
      await fetch(`${API_COM}?action=like`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ comentario_id: comId }),
      });
    } catch {}
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const getYoutubeId = (url) => {
    if (!url) return null;
    const m = url.match(/(?:youtu\.be\/|v=)([^&]+)/);
    return m ? m[1] : url;
  };

  if (loading) return (
    <div className="artd-page">
      <nav className="nav"><Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link></nav>
      <div className="artd-loading"><div className="artd-loading__spinner"/><p>Cargando artículo…</p></div>
    </div>
  );
  if (!art) return null;

  const fecha      = new Date(art.created_at).toLocaleDateString('es-PE',{day:'2-digit',month:'long',year:'numeric'});
  const color      = CAT_COLORS[art.categoria] || '#82D8B3';
  const youtubeId  = getYoutubeId(art.video_youtube);
  const minLectura = calcLectura(art.contenido);
  const urlEnc     = encodeURIComponent(window.location.href);
  const titEnc     = encodeURIComponent(art.titulo);
  const comsPub    = comentarios.filter(c => c.aprobado);

  const ShareRow = () => (
    <div className="artd-share">
      <span className="artd-share-label">Compartir:</span>
      <ShareBtn href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://centrocomunicar.com/articulo.php?slug=' + art.slug)}`}
 bg="#1877f2"><IcoFacebook/> Facebook</ShareBtn>
      <ShareBtn href={`https://wa.me/?text=${titEnc}%20${urlEnc}`} bg="#25d366"><IcoWhatsapp/> WhatsApp</ShareBtn>
      <ShareBtn href={`https://twitter.com/intent/tweet?url=${urlEnc}&text=${titEnc}`} bg="#000"><IcoX/> X</ShareBtn>
      <ShareBtn href={`https://www.linkedin.com/shareArticle?mini=true&url=${urlEnc}&title=${titEnc}`} bg="#0077b5"><IcoLinkedin/> LinkedIn</ShareBtn>
      <button onClick={copyLink} className="artd-copy-btn">
        {copied ? '✓ ¡Copiado!' : '🔗 Copiar enlace'}
      </button>
    </div>
  );

  return (
    <div className="artd-page">
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones">Cursos</Link>
          <Link to="/recursos">Materiales</Link>
          <Link to="/articulos" style={{color:'#4db88a',fontWeight:700}}>Artículos</Link>
          <Link to="/comunidad">Comunidad</Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      <div className="artd-breadcrumb">
        <Link to="/articulos">← Artículos</Link>
        {art.categoria && <><span>/</span><span>{art.categoria}</span></>}
      </div>

      <div className="artd-layout">

        {/* ── ARTÍCULO ── */}
        <article className="artd-article">

          <header className="artd-header">
            {art.categoria && <span className="artd-cat" style={{background:color}}>{art.categoria}</span>}
            <h1 className="artd-titulo">{art.titulo}</h1>

            <div className="artd-autor-row">
              <Avatar nombre={art.autor} size={42}/>
              <div>
                <span className="artd-autor-nombre">{art.autor}</span>
                <div className="artd-autor-meta">
                  <span>📅 {fecha}</span>
                  <span>👁 {art.vistas} vistas</span>
                  <span>⏱ {minLectura} min de lectura</span>
                </div>
              </div>
            </div>

            {art.resumen && <p className="artd-resumen">{art.resumen}</p>}
            <ShareRow/>
          </header>

          {art.imagen_portada && <img src={art.imagen_portada} alt={art.titulo} className="artd-portada"/>}

          {youtubeId && (
            <div className="artd-video">
              <iframe src={`https://www.youtube.com/embed/${youtubeId}`} title={art.titulo} allowFullScreen style={{width:'100%',height:'100%',border:'none'}}/>
            </div>
          )}

          {art.contenido && <div className="artd-contenido" dangerouslySetInnerHTML={{__html:art.contenido}}/>}

          {art.imagenes?.length > 0 && (
            <div className="artd-galeria">
              <h3>Galería</h3>
              <div className="artd-galeria__grid">
                {art.imagenes.map(img => (
                  <a key={img.id} href={img.url} target="_blank" rel="noopener noreferrer">
                    <img src={img.url} alt=""/>
                  </a>
                ))}
              </div>
            </div>
          )}

          {art.tags?.length > 0 && (
            <div className="artd-tags">
              <span className="artd-tags-label">Etiquetas:</span>
              {art.tags.map(tag => (
                <Link key={tag} to={`/articulos?tag=${encodeURIComponent(tag)}`} className="artd-tag">#{tag}</Link>
              ))}
            </div>
          )}

          <div className="artd-share-bottom">
            <p>¿Te gustó este artículo? ¡Compártelo!</p>
            <ShareRow/>
          </div>

          <div className="artd-divider"/>

          {/* ── COMENTARIOS ── */}
          <section className="artd-comentarios">
            <h2 className="artd-comentarios-titulo">
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Comentarios
              {comsPub.length > 0 && <span className="artd-com-count">{comsPub.length}</span>}
            </h2>

            {comsPub.length === 0
              ? <div className="artd-com-empty"><p>Sé el primero en comentar este artículo.</p></div>
              : (
                <div className="artd-com-lista">
                  {comsPub.map(com => (
                    <div key={com.id} className={`artd-com ${com.es_autor ? 'artd-com--autor' : ''}`}>
                      <Avatar
                        nombre={com.nombre} size={38}
                        bg={com.es_autor ? '#edfaf4' : '#111614'}
                        color={com.es_autor ? '#4db88a' : '#82D8B3'}
                      />
                      <div className="artd-com__body">
                        <div className="artd-com__head">
                          <span className="artd-com__nombre">{com.nombre}</span>
                          {com.es_autor && <span className="artd-com__badge-autor">Autor</span>}
                          <span className="artd-com__fecha">
                            {new Date(com.created_at).toLocaleDateString('es-PE',{day:'2-digit',month:'short',year:'numeric'})}
                          </span>
                        </div>
                        <p className="artd-com__texto">{com.texto}</p>
                        <button
                          className={`artd-com__like ${likes[com.id] ? 'artd-com__like--activo' : ''}`}
                          onClick={() => darLike(com.id)}
                          disabled={!!likes[com.id]}
                        >
                          <svg viewBox="0 0 24 24" fill={likes[com.id]?'#4db88a':'none'} width="14" height="14">
                            <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z" stroke="#4db88a" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" stroke="#4db88a" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          Me gusta {com.likes > 0 && `· ${com.likes}`}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )
            }

            {/* Formulario */}
            <div className="artd-com-form">
              <h3 className="artd-com-form-titulo">Deja tu comentario</h3>
              {comMsg && (
                <div className={`artd-com-msg artd-com-msg--${comMsg.tipo}`}>
                  {comMsg.tipo === 'ok' ? '✅' : '⚠️'} {comMsg.texto}
                </div>
              )}
              <div className="artd-com-form-grid">
                <div className="artd-com-field">
                  <label>Nombre <span style={{color:'#dc2626'}}>*</span></label>
                  <input type="text" placeholder="Tu nombre" value={formCom.nombre}
                    onChange={e => setFormCom(p=>({...p,nombre:e.target.value}))}/>
                </div>
                <div className="artd-com-field">
                  <label>Correo <span style={{fontSize:'.72rem',color:'#9ca3af',fontWeight:400}}>(no se publica)</span></label>
                  <input type="email" placeholder="tu@correo.com" value={formCom.email}
                    onChange={e => setFormCom(p=>({...p,email:e.target.value}))}/>
                </div>
              </div>
              <div className="artd-com-field" style={{marginBottom:'.8rem'}}>
                <label>Comentario <span style={{color:'#dc2626'}}>*</span></label>
                <textarea rows="4" placeholder="Escribe tu comentario aquí…" value={formCom.texto}
                  onChange={e => setFormCom(p=>({...p,texto:e.target.value}))}/>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'.5rem'}}>
                <span style={{fontSize:'.75rem',color:'#9ca3af'}}>Tu comentario será revisado antes de publicarse.</span>
                <button className="artd-com-submit" onClick={enviarComentario} disabled={enviando}>
                  {enviando ? 'Enviando…' : '✈ Publicar comentario'}
                </button>
              </div>
            </div>
          </section>
        </article>

        {/* ── SIDEBAR ── */}
        <aside className="artd-sidebar">
          <div className="artd-sidebar-card">
            <h3>Sobre el artículo</h3>
            <div className="artd-sidebar-info">
              <div><span>Autor</span><strong>{art.autor}</strong></div>
              <div><span>Publicado</span><strong>{fecha}</strong></div>
              {art.categoria && <div><span>Categoría</span><strong style={{color:color}}>{art.categoria}</strong></div>}
              <div><span>Lectura</span><strong>{minLectura} min</strong></div>
              <div><span>Vistas</span><strong>{art.vistas}</strong></div>
            </div>
          </div>

          {art.relacionados?.length > 0 && (
            <div className="artd-sidebar-card">
              <h3>Artículos relacionados</h3>
              <div className="artd-sidebar-rel">
                {art.relacionados.map(rel => (
                  <Link key={rel.id} to={`/articulos/${rel.slug}`} className="artd-sidebar-rel-item">
                    {rel.imagen_portada
                      ? <img src={rel.imagen_portada} alt={rel.titulo}/>
                      : <div className="artd-sidebar-rel-placeholder">📝</div>
                    }
                    <div>
                      <strong>{rel.titulo}</strong>
                      <span>{new Date(rel.created_at).toLocaleDateString('es-PE',{day:'2-digit',month:'short'})}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}

          <div className="artd-sidebar-cta">
            <p>🎓 ¿Quieres aprender más?</p>
            <strong>Explora nuestros cursos especializados</strong>
            <Link to="/formaciones" className="artd-sidebar-cta-btn">Ver cursos →</Link>
          </div>
        </aside>
      </div>

      <footer className="footer">
        <div className="footer__bottom" style={{textAlign:'center',padding:'2rem'}}>
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}